export default "__VITE_ASSET__DPflOSiB__"